
export type Agenti = {
  id?: string;
  coddip?: string;
  nomeagente?: string;
  ditta?: number;
  codagente?: string;
}

export type AgentiApiResponse = {
  results: Array<Agenti>;
  count: number;
};

export function mapJsonToAgentiApiResponse(jsonData: any): AgentiApiResponse {
  const mappedData: AgentiApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
        id: item.VBT10_ID,
        coddip: item.VBT10_CODDIP,
        nomeagente: item.VBT10_NOMEAGENTE,
        ditta: item.VBT10_DITTA,
        codagente: item.VBT10_CODAGENTE,
    })),
  };
  return mappedData;
}

export type ReportCliIns = {
  id?: string;
  ditta?: number;
  nomeditta?: string;
  codcli?: number;
  ragsoccli?: string;
  nomeagente?: string;
  indcliblocdesc?: string;
};

export type ReportCliInsApiResponse = {
  results: Array<ReportCliIns>;
  count: number;
};


export function mapJsonToReportCliInsApiResponse(
  jsonData: any
): ReportCliInsApiResponse {
  const mappedData: ReportCliInsApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      id: item.VBT53_ID,
      ditta: item.VBT53_DITTA,
      nomeditta: item.VBT53_NOMEDITTA,
      codcli: item.VBT53_CODCLI,
      ragsoccli: item.VBT53_RAGSOCCLI,
      nomeagente: item.VBT53_NOMEAGENTE,
      indcliblocdesc: item.VBT53_INDCLIBLOCDESC,
    })),
  };

  return mappedData;
}



export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };


export type ReportDateForm = {
                fromDate?     :Date;
                toDate?      :Date;
                emailTo?      :string;
  };





